// ============================================================
// PARALLAX BANNER — Bijouterie Suisse
// Effet de parallax léger pour les sections "image banner"
// L'image se déplace à 40% de la vitesse du scroll sur desktop
// L'image se déplace à 70% sur mobile (effet plus subtil)
// ============================================================

(function() {
  'use strict';

  // Configuration des vitesses (1 = scroll normal, 0 = totalement fixe)
  const SPEED_DESKTOP = 0.4;  // L'image bouge à 40% du scroll
  const SPEED_MOBILE = 0.7;   // L'image bouge à 70% du scroll (plus subtil)
  const MOBILE_BREAKPOINT = 750;

  // Détection : préfère-t-on les animations réduites ? (accessibilité)
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    console.log('[Parallax] Désactivé (préférences accessibilité)');
    return;
  }

  // Détection mobile
  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  // Récupère toutes les bannières avec parallax actif
  function getParallaxBanners() {
    return document.querySelectorAll('.banner__media.animate--parallax');
  }

  // Applique le décalage parallax à une image
  function applyParallax(banner) {
    const rect = banner.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Si la bannière n'est pas dans la zone visible (avec marge), on ne fait rien
    if (rect.bottom < -windowHeight || rect.top > windowHeight * 2) {
      return;
    }

    // Calcul de la position de l'image par rapport au centre de la fenêtre
    const bannerCenter = rect.top + (rect.height / 2);
    const windowCenter = windowHeight / 2;
    const distanceFromCenter = bannerCenter - windowCenter;

    // Vitesse selon device
    const speed = isMobile() ? SPEED_MOBILE : SPEED_DESKTOP;

    // Le décalage : (1 - speed) signifie que si speed = 0.4,
    // l'image se décale de 60% de la distance, donnant l'illusion qu'elle "traîne"
    const offset = distanceFromCenter * (1 - speed) * -1;

    // Trouver l'image dans la bannière
    const img = banner.querySelector('img');
    if (img) {
      img.style.transform = `translateY(${offset}px)`;
      img.style.willChange = 'transform';
    }
  }

  // Met à jour toutes les bannières
  function updateAllBanners() {
    const banners = getParallaxBanners();
    banners.forEach(applyParallax);
  }

  // Gestion fluide du scroll avec requestAnimationFrame
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateAllBanners();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Initialisation
  function init() {
    const banners = getParallaxBanners();
    if (banners.length === 0) {
      return; // Aucune bannière parallax sur cette page
    }

    console.log(`[Parallax] Initialisé sur ${banners.length} bannière(s)`);

    // Mise à jour initiale
    updateAllBanners();

    // Écoute du scroll
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateAllBanners, { passive: true });
  }

  // Démarrage
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();